import CtSelectYear from '@/components/crossTabulation/selectYear'
import CtGenerateExcel from '@/components/crossTabulation/generateExcel'
import CtSelectLocation from '@/components/crossTabulation/selectLocation'
import CtSelectRowVariable from '@/components/crossTabulation/selectRowVariable'
import CtSelectColumnVariable from '@/components/crossTabulation/selectColumnVariable'
import CtSelectControlVariables from '@/components/crossTabulation/selectControlVariables'
import CtSelectStatistics from '@/components/crossTabulation/selectStatistics'
import CtViewReport from '@/components/crossTabulation/viewReport'

export default {
    routes: [
        { path: '/crossTabulation/selectLocation', name: 'crossTabulationSelectLocation', component: CtSelectLocation },
        { path: '/crossTabulation/selectRowVariable', name: 'crossTabulationSelectRowVariable', component: CtSelectRowVariable },
        { path: '/crossTabulation/selectColumnVariable', name: 'crossTabulationSelectColumnVariable', component: CtSelectColumnVariable },
        { path: '/crossTabulation/selectControlVariables', name: 'crossTabulationSelectControlVariables', component: CtSelectControlVariables },
        { path: '/crossTabulation/selectStatistics', name: 'crossTabulationSelectStatistics', component: CtSelectStatistics },
        { path: '/crossTabulation/viewReport', name: 'crossTabulationViewReport', component: CtViewReport },
        { path: '/crossTabulation/generateExcel', name: 'crossTabulationGenerateExcel', component: CtGenerateExcel },
        { path: '/crossTabulation/:selectYear?', name: 'crossTabulationSelectYear', component: CtSelectYear }
    ]
    //getRoutes: () => this.routes || (this.routes = buildRoutes(this))
}

